export default __webpack_public_path__ + "static/media/note404.7c781ba0.svg";